import { IOffer } from 'types';

export const offerVisaSupport = (offer: IOffer, config: any, casBypass: boolean, hasAgent: boolean) => {
  if (casBypass) {
    return false;
  }
  if (config.otherOptions.visaSupport === 'MANDATORY') {
    return !hasAgent;
  }
  if (config.otherOptions.visaSupport === 'MANDATORY_ALL') {
    return true;
  }
  if (offer.hasOwnProperty('visaSupport')) {
    return !!offer.visaSupport;
  }
  if (config.otherOptions.visaSupport === 'INACTIVE') {
    return false;
  }
  return false;
};
